import { render, staticRenderFns } from "./ElBlogCategories.vue?vue&type=template&id=2f80d557"
import script from "./ElBlogCategories.vue?vue&type=script&lang=js"
export * from "./ElBlogCategories.vue?vue&type=script&lang=js"
import style0 from "./ElBlogCategories.vue?vue&type=style&index=0&id=2f80d557&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports